import React, { useState } from "react";

function Donation() {
  const [Input, setInput] = useState();
  return (
    <div className="w-full bg-white py-12">
      <div className="w-full max-w-[800px] m-auto flex justify-center items-center flex-col md:px-6 px-4">
        <h3 className="font-noto font-[500] text-3xl text-center text-black ">
          This winter we want to reach out to the people who are suffering the
          most by bringing joy and hope into their lives.
        </h3>
        <p className="font-noto font-regular text-lg text-black mt-4  text-center">
          With the current cost-of-living crisis, thousands of people are
          expected to turn to The Salvation Army for help this winter. In over
          650 communities across the UK, we will be doing all we can for them,
          whatever their circumstances.
        </p>
        <div className="w-full flex justify-center items-center flex-col md:max-w-[500px] p-6 border-2 border-[gray] shadow-xl rounded-lg my-8">
          <h3 className="font-noto font-[400] text-lg text-center text-black ">
            Please make a donation today!
          </h3>
          <div className="w-full grid grid-rows-2 grid-cols-3 gap-3 my-6">
            {btns.map((item, index) => {
              return (
                <button
                  key={index}
                  onClick={() => setInput(item)}
                  className="rounded-lg h-[40px] bg-main font-noto font-[600] text-lg text-white focus:bg-secondary"
                >
                  ${item}
                </button>
              );
            })}
          </div>
          <input
            type="number"
            value={Input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Select or put amount manually"
            className="w-full border-2 leading-4 border-main font-noto font-[400] text-lg text-black rounded-lg h-[46px] px-3 outline-black"
          />
          <button className="w-full h-[50px] rounded-lg font-noto bg-secondary text-white text-md hover:scale-105 transition-all duration-300 mt-8">
            Donate
          </button>
        </div>
        <p className="font-noto font-regular text-lg text-black mt-4  text-center">
          We want to be there for people who are facing poverty because they
          simply can’t make ends meet. For the families struggling to feed their
          children. For the older people in our communities who have never felt
          as lonely as they do now. For the people who are homeless and trying
          to get back on their feet.
          <br />
          <br />
          For The Salvation Army it is unthinkable that people should be living
          on the streets in the bitter cold. No one should have to live on the
          streets. No family should be without food and heating. No older person
          should have to be alone. That’s why we won’t rest until we’ve reached
          out to as many suffering and vulnerable people as we can.
          <br />
          <br />
          Please support our Winter Appeal so we can provide food parcels,
          practical support and somewhere to sleep for people who are homeless
          this winter.
        </p>
        <h3 className="font-noto font-[600] text-2xl self-start text-center text-black mt-8">
          A gift of:
        </h3>
        <ul className="list-disc list-inside mt-4">
          <li className="font-noto text-md">
            £9 could provide one-to-one support work for a homeless person in
            one of our centres.
          </li>
          <li className="font-noto text-md">
            £19 could help provide a box of groceries so that families who are
            struggling in poverty can share a meal together.
          </li>
          <li className="font-noto text-md">
            £45 could contribute towards the cost of an officer to run a
            Salvation Army centre for a day to keep the door open for vulnerable
            people.
          </li>
        </ul>
        <button className="w-full max-w-[200px] h-[40px] rounded-lg font-noto bg-secondary text-white text-md hover:scale-105 transition-all duration-300 mt-8">
          Donate
        </button>
        <div className="w-full shadow-xl m-auto flex justify-center items-center flex-col md:px-6 bg-secondary/10 rounded-lg mt-10 md:p-10 p-4">
          <h1 className="font-noto font-[600] text-4xl text-center text-black ">
            Our good work direct to your inbox
          </h1>
          <p className="font-noto font-regular text-lg text-main mt-2 text-center">
            We would like to keep in touch with you about our vital work and how
            you can help transform lives.
          </p>
          <div className="w-full max-w-[500px] flex justify-center items-center gap-4 mt-8">
            <input
              type="text"
              placeholder="type your email here"
              className="md:w-[80%] w-[70%] h-[50px] font-noto font-[400] text-lg bg-white rounded-lg px-3 shadow-sm"
            />
            <button className="md:w-[20%] w-[30%] h-[50px] rounded-lg font-noto bg-secondary text-white shadow-sm text-md hover:scale-105 transition-all duration-300">
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Donation;

const btns = [10, 50, 100, 300, 500, 1000];
